export function publicDomain() {
    if (window.location.hostname.includes("localhost"))
        return "tickaroo-staging.com";
    return window.location.hostname.split(".").slice(-2).join(".");
}
//# sourceMappingURL=publicDomain.js.map